import { FETCH_SURVEY_STATUS, UPDATE_SURVEY } from "./actionTypes";

const fetchSurveyStatus = () => ({
    type: FETCH_SURVEY_STATUS,
    errors: null
});

const updateSurvey = (payload) => ({
    type: UPDATE_SURVEY,
    payload,
    errors: null
});

export {
    fetchSurveyStatus,
    updateSurvey
};
